import { Injectable, Optional } from '@angular/core';
import { EMPTY, Observable, of } from 'rxjs';
import { catchError, switchMap, throwIfEmpty } from 'rxjs/operators';
import { INSIDE_DIALOG_TOKEN, TAB_EVENT } from './types';
import { NavigationService } from './navigation.service';
import { AppContext, FrameContext, Repository, UID } from '@farris/devkit';
import { FormMessageService } from './form-message.service';
import { LanguageService } from './languag.service';
import { CardDataService } from './data-services/card-data.service';
import { DataChangeDetectionService } from './data-change-detection.service';
/**
 * å¯¼èªä¸­é´ä»¶æå¡
 * @scope FrameComponent
 */
// tslint:disable: no-string-literal
@Injectable()
export class NavigationMiddlewareService {
  private repository: Repository<any>;

  private appContext: AppContext;
  constructor(
    private navigationService: NavigationService,
    private frameContext: FrameContext,
    private msgService: FormMessageService,
    @Optional() private languageService: LanguageService,
    private cardDataService: CardDataService
  ) {
    this.repository = frameContext.repository;
    if (!this.languageService) {
      this.languageService = LanguageService.getInstance();
    }
    if (this.frameContext) {
      this.appContext = this.frameContext.getFormAppContext() || null;
    }
  }
  /**
   * å³é­åå¤ç
   */
  public onClosing() {
    if (this.isInDialog()) {
      return;
    }
    this.navigationService.addEventListener(TAB_EVENT.onTabClosing, (options) => {
      if (!this.frameContext || this.frameContext.isDisposed) {
        return of(true);
      }
      return this.isChanged.pipe(
        switchMap((changed: boolean) => {
          if (changed && !this.appContext.opened) {
            // å¦æéè¦ç¨æ·ç¡®è®¤å°±åæ¢å°å½åtab
            if (options && options.beforeCloseHandle && typeof options.beforeCloseHandle === 'function') {
              options.beforeCloseHandle({ selectedChange: true });
            }
            const conform = this.msgService.question(this.languageService['exitWithoutSave']);
            /*è®°å½å¼¹çªå·²æå¼*/
            this.appContext.opened = true;
            return conform.pipe(
              switchMap((result: boolean) => {
                this.appContext.opened = false;
                if (result) {
                  /*è®°å½ç¨æ·å³é­å¼¹çª*/
                  if (!!this.cardDataService) {
                    const revert$ = this.cardDataService.revert(options);
                    return revert$.pipe(
                      switchMap(() => of(result))
                    );
                  }
                }
                return of(result);
              })
            );
          } else if (changed && this.appContext.opened) {
            return of(false);
          } else {
            return of(true);
          }
        }),
        catchError((error) => {
          return this.msgService.question(this.languageService.hasChangeCheckFaild).pipe(
            switchMap((result) => {
              return of(result);
            })
          );
        })
      );
    });
  }
  /**
   * æ¯å¦å¨æ¯å¼¹çªçªå£å
   */
  private isInDialog() {
    let frameContext = this.frameContext;
    let isDialogRootComponent = frameContext.frameComponent['isDialogRootComponent'] || false;
    while (frameContext.parent !== null && !isDialogRootComponent) {
      frameContext = frameContext.parent;
      isDialogRootComponent = frameContext.frameComponent['isDialogRootComponent'];
    }
    if (!isDialogRootComponent) {
      isDialogRootComponent = this.frameContext.injector.get<boolean>(INSIDE_DIALOG_TOKEN, false);
    }
    return isDialogRootComponent;
  }
  /**
   * è·åtabid,å¦ætargetIdå­å¨åç´æ¥ä½¿ç¨targetId
   * @description å°ç¨æ·è¦æ¥ççæ°æ®idè½¬æ¢ä¸ºè¿è¡æ¡æ¶éè¦çtabId
   * @param params - routeråæ°
   * @param targetId - è¦ç¼è¾/æ¥ççæ°æ®id
   */
  public getTabId(params: string, targetId: string): any {
    if (!!targetId) {
      return targetId;
    }
    let paramsObj: any = null;
    if (!!params && params.startsWith('{') && params.endsWith('}')) {
      paramsObj = JSON.parse(params);
    }
    let paramId = null;
    if (paramsObj && paramsObj.hasOwnProperty('id') && !!paramsObj.id) {
      paramId = paramsObj.id;
    } else {
      paramId = UID.create();
    }
    return paramId;
  }
  /**
   * æ¯å¦ææªä¿å­çåæ´
   */
  private get isChanged(): Observable<boolean> {
    return DataChangeDetectionService.hasChange(this.frameContext).pipe(throwIfEmpty(() => EMPTY));
  }
}
